import { Controller } from "@hotwired/stimulus";
import { leave, toggle } from "el-transition";

// Connects to data-controller="dropdown"
export default class extends Controller {
  static targets = ["menu", "icon"];

  toggle() {
    const isHidden = this.menuTarget.classList.contains("hidden");
    this.rotateIcon(isHidden);

    toggle(this.menuTarget);
  }

  hide(event) {
    const clickedOutside = !this.element.contains(event.target);
    const isOpen = !this.menuTarget.classList.contains("hidden");

    if (clickedOutside && isOpen) {
      this.rotateIcon(false);
      leave(this.menuTarget);
    }
  }

  rotateIcon(isHidden) {
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("rotate-x-180", isHidden);
    }
  }
}
